/**
 * In this file use to contains the physician Module Add MedicalIssues screen UI and Logic
 **/
import React from 'react'
import { Link,useNavigate,useParams } from 'react-router-dom';
import ApiService from './../../services/ApiService';
import * as Yup from 'yup';
import { useState,useEffect } from 'react';
import { validate } from './../../services/ValidationService';
import { goBack,generateRandomId,convertDOBtoMonth,convertS3privateToPublic,convertDOBtoAge,formatMeasurement } from './../../services/UtilsService';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const AddMedicalIssues = () => {
	//Initial state declaration
	let { id } = useParams();
	const [memberData,setMemberData]=useState([]);
	const [parentData,setParentData]=useState([]);
	const [data,setData]=useState({});
	const [error,setError]=useState({});
	const [addVitals, setAddVitals] = useState("false");
	const [vitalsInfo,setVitalsInfo]=useState([{vitals:'',vitals_value:''}]);
	const [errorvitals,setVitalError]=useState({});
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(true);
	const role = Number(localStorage.getItem('role'));
	const { t } = useTranslation();

	/** 
	* Validation schema for Add Diagnosis Fields
	* @main_problem - required field and pass the diagnosis main_problem
	* @associated_problem - required field and pass the associated_problem
	* @add_vitals - required field and pass the add_vitals in boolean
	* @medical_conditions - required field and pass the medication details
	**/
   const fields = [
    { name: 'main_problem', validation: Yup.string().trim().required(t('error.required')) },
	{ name: 'associated_problem', validation: Yup.string().trim().required(t('error.required'))},
	{ name: 'add_vitals', validation: Yup.string().required(t('error.required'))},
	{ name: 'medical_conditions', validation: Yup.string().required(t('error.required'))}
   ];
   
    const vitalsFields=[
     { name: 'vitalsInfo', validation: Yup.array().of(
		Yup.object({
		  vitals: Yup.string().required(t('error.required')),
		  vitals_value: Yup.string().required(t('error.required'))
		})) },
    ];
	
	const dropdownOptions = [
        { value: '', label: `${t('common.selectVitals')}` },
        { value: '1', label: `${t('table.heartRate')}`},
        { value: '2', label: `${t('table.bloodGlucose')}` },
        { value: '3', label: `${t('table.temperature')}` }
    ];   
   
	//Component Initialize function trigger when request id change
	useEffect(()=>{
		const fetchData = async () => {
			setIsLoading(true); 
			try {
				var response = await ApiService.getMemberProfile(id);
				if(response.status===200){
				 setMemberData({...response.data.item,dobs:convertDOBtoMonth(response.data?.item?.dob)});
				 setParentData(response.data.parentInfo);
				}
			}catch (error) {
				console.error('Error fetching member data:', error);
			} finally {
				setIsLoading(false); 
			}
		};
		fetchData();
	},[id]);
	
	/** 
    * To handle input change event 
    * @e - we get the event details from the Change action
    **/
	const handleChange = async(e) => {
	    const {name,value}=e.target;
		e.preventDefault();
		setData({...data,[name]:value});
	    const Errors=await validate({[name]:value},fields);
	    setError({...error,[name]:Errors[name]});
	};
	
	/** 
   * To handle vitals aad radio change event 
   * @e - we get the event details from the Change action
   **/
    const handleAddVitalsChange = async (e,value) => {
		/* e.preventDefault(); */
		setData({...data,'add_vitals':value});
	    /* if (value === 'false' && addVitals === 'true') {
			setVitalsInfo([{ vitals: '', vitals_value: ''}]);
	    } */
		setAddVitals(value);
		const Errors=await validate({'add_vitals':value},fields);
		await setError({...error,'add_vitals':Errors['add_vitals']});
		await setVitalError({...error,'add_vitals':Errors['add-vitals'], 'vitalsInfo': Errors['vitalsInfo']});
	};
	
	  /** 
   * To handle radio input change event 
   * @e - we get the event details from the Change action
   **/
    const handleRadioChange = async (e,item) => {
	   const {name,value}=e.target;
	   await setData({ ...data, medical_conditions: item });
	   const Errors=await validate({[name]:value},fields);
	   await setError({...error,[name]:Errors[name]});
	};
	
	//To add vitalsInfo
	const addVitalsInfo=(index)=>async(e)=>{
		e.preventDefault();
		const Errors = await validate({'vitalsInfo':vitalsInfo}, vitalsFields);
		await setVitalError(Errors);
		if(!Object.keys(Errors).length && vitalsInfo.length < 3){
			await setVitalsInfo(state => [...state, {vitals:'',vitals_value:''}]);
			const Errors = await validate({'vitalsInfo':[{vitals:'',vitals_value:''}]}, vitalsFields);
			await setVitalError( Object.keys(Errors).reduce((acc, key) => ({ ...acc, [key.replace(/\[0\]/g, `[${index + 1}]`)]: Errors[key] }), {})
			);
		}
	};
	
	//To remove vitalsInfo
	const removeVitalsInfo=(index)=>async(e)=>{
		e.preventDefault();
		if(vitalsInfo.length !==1){
			const updatedVitals = [...vitalsInfo];
            updatedVitals.splice(index, 1);
            setVitalsInfo(updatedVitals);
			// Validate the updated vitals info
			const updatedVitalsErrors = await validate({ 'vitalsInfo': updatedVitals }, vitalsFields);
			setVitalError(updatedVitalsErrors);
		}else{
			await setVitalsInfo([{vitals:'',vitals_value:''}]);
			await setVitalError(await validate({'vitalsInfo':[]}, vitalsFields));
		};
	};
	
	//To handle the vitalsInfo change
	const changeVitalsInfo=(index)=>async (e)=>{
		e.preventDefault();
		const { name,value } = e.target;
		const updatedVitals = [...vitalsInfo];
        updatedVitals[index] = { ...updatedVitals[index], [name]: value };
		if(name==='vitals'){
			 updatedVitals[index].vitals_value = '';
		}		
        setVitalsInfo(updatedVitals);
		
		const Errors = await validate({'vitalsInfo':updatedVitals}, vitalsFields);
		setVitalError(Errors);
	};
	
	//To handle the vitals options
	const getAvailableOptions = (currentIndex) => {
        const selectedVitals = vitalsInfo.map(item => item.vitals);
        const availableOptions = dropdownOptions.filter(option => !selectedVitals.includes(option.value) || option.value === vitalsInfo[currentIndex].vitals);
        return availableOptions;
    };
		
	
	/** 
   * To handle the form submit event 
   * @e - we get the event details from the form submit action
   **/	
	const handleSubmit=async(e)=>{
		e.preventDefault();
		const Errors=await validate(data,fields);
		const vitalsErrors = await validate({ 'vitalsInfo': vitalsInfo }, vitalsFields);
		setVitalError(vitalsErrors);
		await setError(Errors);
		const vitals = addVitals === 'true' ? !Object.keys(vitalsErrors).length : 'true';
		if(!Object.keys(Errors).length && vitals ){
			const vitalsData = vitalsInfo.map((item) => {
				const category = parseInt(item.vitals);
				let value = item.vitals_value;

				// Convert Fahrenheit to Celsius if the vital is Temperature (value '3')
				if (category === 3 && value !== '' && !isNaN(value)) {
					value = ((parseFloat(value) - 32) * 5 / 9).toFixed(2); // 2 decimal places
				}

				return {
					id: generateRandomId(),
					category,
					value
				};
			});
			data.id=generateRandomId();
			data.vitals=vitalsData;
			data.member = memberData?.id;
			data.parent = memberData?.parent;
			var response = await ApiService.createMedicalIssue(data);
			if(response.status===200){
				toast.success(response?.data?.message);
				if(role===4){
					navigate("/hospital/admin/children");
				}else{
					navigate('/physician/medical-issues');  
				}
			}else{
				toast.error(response?.data?.message);
			}
		}
	};
	
	//To handle the form reset
	const handleCancel =() => {
		setData({});
		setError({});
		setVitalError({});		
		setVitalsInfo([{vitals:'',vitals_value:''}]);
		setAddVitals("false");
		// Reset the radio buttons
		document.getElementById("add_vitals_1").checked = false;
		document.getElementById("add_vitals_2").checked = false;
		document.getElementById("medicalConditions1").checked = false;
		document.getElementById("medicalConditions2").checked = false;
	}
	
   return (
    <main id="main" className="main">
    {/* Page Title Section */}
    <div className="pagetitle clearfix">
        <div className="float-start">
          <h1>{t('common.addMedicalIssues')}</h1>
            <nav>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><Link to={role===4 ? '/hospital/admin/dashboard' : '/physician/dashboard'}>{t('sidebar.home')}</Link></li>
                  <li className="breadcrumb-item active">{t('common.addMedicalIssues')}</li>
                </ol>
            </nav>
        </div>
        <div className="float-end mt-2 me-1">
            <span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
        </div>{/* End Buttons */}
    </div>
    {/* End Page Title Section */}
    {/* Page Content Section */}
    <section className="pagesection">
        <div className="row">
            <div className="col-xxl-12">
                <form className="form-card p-2">	
				{/* Patient(kids) Info */}
					{!isLoading && 
					<>
					<div className="row">				
						<div className={memberData?.gender === 0 ? "male col-lg-12" : "female col-lg-12"}>
							<div className="d-md-flex align-items-center ps-1">
								<div className="avtar-img">
									<span className="rounded-circle">
									{memberData?.photo==='default.png'?<img src="/assets/img/user-avatar.png" alt="UN" />:<img src={convertS3privateToPublic(memberData?.photo)} alt="UN" />}
									</span>
								</div>
								<div className="ms-lg-2">
									<Link to={role === 4 ? '/hospital/admin/view-children/' + memberData?.id : '/physician/member-profile/' + memberData?.id}><h5 className="table-title fw-bold">{memberData?.name ? memberData?.name : '--'}</h5></Link>
									<p className={`table-subtitle ${role === 4 ? 'admin-table-subtitle' : ''}`}><span>{memberData.gender === 0? t('common.boy') :  t('common.girl')}</span>{" "} - {convertDOBtoAge(memberData.dob, t)}</p>
								</div>
								<div className="ms-lg-5">
									<p className="mb-0 small">{t('sidebar.parent')}</p>
									<p className="mb-0 table-subtitle">{parentData?.first_name+' '+parentData?.last_name}</p>
								</div>
								<div className="ms-lg-5">
									<p className="mb-0 small">{t('table.bloodGroup')}</p>
									<p className="mb-0 table-subtitle">{memberData?.blood_group ? memberData?.blood_group+' ve' : '--'}</p>
								</div>
								<div className="ms-lg-5">
									<p className="mb-0 small">{t('table.weight')} / {t('table.height')}</p>
									<p className="mb-0 table-subtitle">
									{memberData.latest_weight && memberData.latest_weight !== '0' ?`${formatMeasurement(memberData.latest_weight)} ${t('common.kg')}`	: '--'}
									<span className="mx-2" style={{color:'black'}}>/</span> {memberData?.latest_height && memberData.latest_height!== '0' ? `${formatMeasurement(memberData.latest_height)} ${t('common.cm')}`	: '--'}
									</p>
								</div>
							</div>
						</div>	
					</div>	
					<hr className="my-3"/>	
					</>}
					{ /* Patient Kids Info section end */}
                    <div className="row">					
                        <div className="col-lg-4 col-md-6">
                            <div className="form-group">
                                <label>{t('table.mainProblem')}</label>
                                <input type="text" name="main_problem" value={data.main_problem||''} className="form-control" onChange={handleChange} placeholder={t('common.placeHolderMainProblem')} />
								{error && error.main_problem && <span className="required">{error.main_problem}</span>}
                            </div>
                        </div>	
                        <div className="col-lg-4 col-md-6">
                            <div className=" form-group">
                                <label>{t('table.associatedProblem')}</label>
                                <input type="text" name="associated_problem" value={data.associated_problem||''} className="form-control" onChange={handleChange} placeholder= {t('common.placeHolderAssProblem')} />
								{error && error.associated_problem && <span className="required">{error.associated_problem}</span>}
                            </div>
                        </div>	
						<div className="col-lg-4 col-md-6">
                            <div className=" form-group">
                                <label>{t('common.addVitals')}</label>
                                <div className="ChecksRadios" style={{backgroundColor:"#f0f4f4"}}>
                                    <div className="form-check form-check-inline">
                                        <input className={`form-check-input ${role === 4 ? 'admin-form-check-input' : ''}`} type="radio" name="add_vitals" onChange={(e)=>handleAddVitalsChange(e,"true")} id="add_vitals_1" value="true"  checked={data.add_vitals === "true"} />
                                        <label className="form-check-label" htmlFor="add_vitals_1"> {t('modal.yes')}</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className={`form-check-input ${role === 4 ? 'admin-form-check-input' : ''}`} type="radio" name="add_vitals" onChange={(e)=>handleAddVitalsChange(e,"false")} id="add_vitals_2" value="false"  checked={data.add_vitals === "false"}/>
                                        <label className="form-check-label" htmlFor="add_vitals_2"> {t('modal.no')}</label>
                                    </div>
                                </div>
								{error && error.add_vitals && <span className="required">{error.add_vitals}</span>}
                            </div>
                        </div>		
                    </div>	
					{addVitals === "true" && (
                    <div className="row">																						
                        <div className="col-lg-12">
                            <div id="vitals_fields"></div>	
                            { vitalsInfo && vitalsInfo.map((item,i)=>( <div key={i} className="form-group row">										
                                <div className="col-lg-5 col-md-6 mb-3">
                                    <label>{t('table.vitals')}</label>
                                    <select name="vitals" value={item.vitals?item.vitals:''} onChange={changeVitalsInfo(i)} className="form-select">
                                        {getAvailableOptions(i).map((option) => (
											<option key={option.value} value={option.value} disabled={option.value === ''} >{option.label}</option>
										))}
                                    </select>
									{errorvitals && (errorvitals['vitalsInfo['+i+'].vitals']) && <span className="required">{(errorvitals['vitalsInfo['+i+'].vitals'])}</span>}
                                </div>										
                                <div className="col-lg-5 col-md-6 mb-3">
                                    <label>{t('common.vitalUnit')} </label>
                                    <div className="input-group">
                                        <input type="number" name="vitals_value" onChange={changeVitalsInfo(i)} value={item.vitals_value||''} className="form-control w-75" placeholder={t('common.enterVitalUnit')}
										onInput={(e) => {
											const inputValue = e.target.value;
											// Ensure no negative values
											if (inputValue < 0) {
												e.target.value = '';
												return;
											}

											if (item.vitals === '1') {											
												if (/[^\d]/.test(inputValue) || inputValue.length > 3) {
													e.target.value = inputValue.slice(0, Math.min(inputValue.length, 3)).replace(/[^0-9]/g, ''); 
												}
											} else {										
												if (inputValue.length > 5) {
													e.target.value = inputValue.slice(0, 5); 
												}
											}
										}}/>
										  <select name="vitals_unit" onChange={changeVitalsInfo(i)}  disabled={!!item.vitals} value={item.vitals_unit||''} className="form-select w-25">
											{/*<option value="" disabled>Unit</option>*/}
                                            {item.vitals === '1' && <option value="1">bpm</option>}
										    {item.vitals === '2' && <option value="2">mg/dL</option>}
										    {item.vitals === '3' && <option value="3">°F</option>}					
										   </select>
										    
										{errorvitals && (errorvitals['vitalsInfo['+i+'].vitals_value']) && <span className="required">{(errorvitals['vitalsInfo['+i+'].vitals_value'])}</span>}
                                    </div>
                                </div>											
                                <div className="col-lg-1 col-md-2  mb-3">
									<label>&nbsp; </label>
									<div className="d-flex" style={{margin:"-28px 0"}}>
										<button  onClick={removeVitalsInfo(i)} style={{"margin": "28px 15px 0px 0px"}} type="button" className="btn btn-outline-danger py-2"><i className="ri-close-fill"></i></button>
										{vitalsInfo.length && vitalsInfo.length-1=== i && 
											<button type="button" className={`btn ${role===4?'btn-outline-tmAquaDgreen':'btn-outline-tmBlue'} py-2 btn-48px`}  style={{"margin": "28px 15px 0px 0px"}} onClick={addVitalsInfo(i)}> 
												<i className="ri-add-fill align-middle"></i>
											</button>
										}
									</div>
                                </div>
                            </div>))}	
                        </div>	
                    </div>
					 )}
                    
                    <div className="row">				
                        <div className="col-lg-6 col-md-6">
                            <div className=" form-group">
                                <label>{t('common.medicalQuestion')} </label>
                                <div className="ChecksRadios" style={{backgroundColor:"#f0f4f4"}}>
                                    <div className="form-check form-check-inline">
                                      <input className={`form-check-input ${role === 4 ? 'admin-form-check-input' : ''}`} type="radio" name="medical_conditions" onChange={(e)=>handleRadioChange(e,"true")} id="medicalConditions1" value="true" checked={data.medical_conditions === "true"} />
                                      <label className="form-check-label" htmlFor="medicalConditions1"> {t('modal.yes')}</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                      <input className={`form-check-input ${role === 4 ? 'admin-form-check-input' : ''}`} type="radio" name="medical_conditions" onChange={(e)=>handleRadioChange(e,"false")} id="medicalConditions2" value="false" checked={data.medical_conditions === "false"} />
                                      <label className="form-check-label" htmlFor="medicalConditions2"> {t('modal.no')}</label>
                                    </div>
                                </div>
								{error && error.medical_conditions && <span className="required">{error.medical_conditions}</span>}
                            </div>
                        </div>		
                    </div>	
                    
                    {/* Button Section */}
                    <div className="row">								
                        <div className="col-lg-12 text-end">
                            <button type="button" className={`btn ${role===4?'btn-tmAquaDgreen':'btn-secondary'} me-2`} onClick={handleCancel}><i className="ri-arrow-left-line align-middle"></i> {t('common.reset')} </button>
                            <button type="submit" className={`btn ${role===4?'btn-tmAquaGreen':'btn-tmBlue'}`} onClick={handleSubmit}><i className="ri-check-double-fill align-middle"></i> {t('profile.submit')}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>	
    </section>
    {/* End Page Content Section */}
</main>
  )
}

export default AddMedicalIssues
